import { RG_TYPE as t } from "@project-rouge/rg-core";
import { getRgObjectsAtLevel as o } from "../../../utils/rg-util/index3.js";
import { isFireCore as i } from "../../queries/index4.js";
const n = (r, e) => o(r, t.Core, e).filter(i).length;
export {
  n as getFireCoreCount
};
//# sourceMappingURL=index20.js.map
